export const sanitizeHeadingId = (headingId?: string) => {
  if (!headingId) return "";

  return headingId
    .replace(/[^a-z0-9-]/gi, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
};
